<!--  -->
<template>
  <div>
    <div class="band_box">
      <div>
        <div class="serch_box search_box">
          <!-- <el-input v-model="obr.friend_id" placeholder="请输入自有员工编号" style="width:200px" />
          <el-input v-model="obr.name" placeholder="请输入员工姓名" style="width:200px;margin-left:10px" /> -->
          <el-input v-if="valueser==3" v-model="employee_no" clearable style="width:400px;" placeholder="请输入发言人编号" />
          <el-input v-else v-model="obr.nickname" clearable style="width:400px;" placeholder="请输入发言人姓名" />
          <el-select v-model="valueser" placeholder="请选择" @change="chaerwr">
            <el-option
              v-for="item in optionsalll"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button type="primary" class="search_icon" icon="el-icon-search" @click="secahclkick" />
        </div>
        <div class="choses_box">
          <div class="select_box" :class="[fullName?'choose_blockr':'']" @click="whole" />
          <div v-if="fullName" @click="whole">
            取消全选
          </div>
          <div v-else @click="whole">
            全选
          </div>
        </div>
        <div class="choose_allblock">
          <div v-for="item,index in arr" :key="index" :class="[item.tips?'have ':'']" class="choose_block">
            <!-- {{ item.canChecked }} -->
            <div v-if="item.can_checked === 9" class="select_boxone" />
            <div v-else class="select_box" :class="[item.tips?'choose_blockr':'']" @click="itenclick(item,index)" />
            <span>{{ item.nickname }}</span>
          </div>
        </div>

      </div>
      <div class="rigboxr">
        <div class="choiceofficialaccount">选中的发言人</div>
        <el-tag
          v-for="itemr,index in arrs"
          :key="index"
          style="margin-right:10px;margin-bottom:5px"
          closable
          :type="itemr.type"
          @close="rightclick(itemr.friend_id,index)"
        >
          {{ itemr.nickname }}
        </el-tag>
      </div>
    </div>
    <!-- <pagination-right
      style="padding:0px;margin-top:20px"
      :total="total"
      :current-page="obr.page"
      :page-size="30"
      :page-sizes="[10,20,30]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    /> -->
    <div class="que_box">
      <el-button type="primary" @click="quebtn">确定</el-button>
    </div>

  </div>
</template>

<script>
// import PaginationRight from '@/components/PaginationRight/index.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
import { groupToEmployeeslistr, groupChatSetgetCorpColleagues, getCorpColleaguesUnrestricted } from '@/api/officialaccount.js'
export default {
  components: {
    // PaginationRight
  },
  mixins: [convertToHump],
  data() {
    return {
      employee_no: null,
      searchvalue: null,
      searchTopicLoading: false, // 搜索锁
      topicList: [], // 公众号临时绑定数组
      options: [], // 公众号列表数组
      value1: [], // 公众号多选完成集合数组
      id: null, // 点击保存的id
      tableData: [], // 表格数组
      arr: [],
      arrs: [],
      arrsw: [],

      obr: {
        // page: 1,
        // page_size: 30,
        employee_no: null,
        nickname: ''
      },
      total: null,
      sp_strategy_no: null,
      valueser: 1,
      corp_id: null,
      condition: false,
      sendr_wx_id: null
    }
  },
  computed: {
    optionsalll() {
      const options = [
        {
          value: 1,
          label: '外部'
        },
        {
          value: 2,
          label: '内部'
        }
      ]
      if (this.condition) {
        options.push({
          value: 3,
          label: '企微宝'
        })
      }
      return options
    },
    fullName: function() {
      return this.arr.filter((num) => {
        return num.can_checked !== 9
      }).every(function(item) {
        return item.tips === true
      })
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    secahclkick() {
      // this.obr.page = 1
      this.list()
    },

    // 点击确定
    async quebtn() {
      console.log('arrs', this.arrs)
      this.arrsw = []
      this.arrsw = this.arrs.map(item => { // item是数组中的每一个值
        return item.friend_id
      })
      if (this.arrs.length === 0) {
        this.$message.error('请选择要设置的发言人')
        return
      }
      this.$emit('bandarr', this.arrs, this.obr.employee_no)
      console.log('this.arrs', this.arrs)
    },

    itenclick(item, index) {
      console.log('item, index:', item, index)
      item.tips = !item.tips
      if (item.tips) {
        this.arrs.push({ friend_id: item.friend_id, nickname: item.nickname })
      } else {
        const index = this.arrs.findIndex((items) => {
          return items.friend_id === item.friend_id
        })
        this.arrs.splice(index, 1)
      }
    },
    whole() {
      if (this.fullName === true) {
      // if (this.arrs.length === this.arr.length) {
        console.log('666')
        this.arr.forEach((item) => {
          if (item.can_checked === 1) {
            item.tips = false
            const index = this.arrs.findIndex((items) => {
              return items.friend_id === item.friend_id
            })
            this.arrs.splice(index, 1)
          }
        })
      } else {
        console.log('777')
        this.arr.forEach((item) => {
          if (item.can_checked === 1) {
            item.tips = true
            this.arrs.map(re => re.friend_id).includes(item.friend_id) || this.arrs.push({ friend_id: item.friend_id, nickname: item.nickname })
          }
        })
        // this.arr.forEach((item) => {
        //   this.arrs.includes(item.id) || this.arr.push(item.id)
        // })
      }
    },
    rightclick(friend_id, index) {
      console.log(friend_id, index)
      this.arrs.splice(index, 1)
      this.arr.findIndex((items) => {
        if (items.friend_id === friend_id) {
          items.tips = false
        }
      })
    },
    sendr(arr, employee_no, corp_id, number, blo) {
      console.log('  this.condition :', this.condition)
      // this.condition = blo
      console.log('arr:', arr)
      this.arrs = arr
      this.obr.employee_no = employee_no
      this.corp_id = corp_id
      // this.obr.group_chat_id = group_chat_id
      // this.obr.corp_id = corp_id
      this.list()
    },
    async list() {
      console.log('arr1111111111111111')
      if (this.valueser === 1) {
        const data = await groupToEmployeeslistr(this.obr)
        // this.total = data.data.total
        if (data.data === null) {
          this.arr = []
        } else {
          data.data.forEach((item) => {
            item.can_checked = 1
            item.tips = false
          })
          this.arr = data.data

          this.arr.forEach((item) => {
            // console.log('item', item)
            this.arrs.forEach((items) => {
              if (items.friend_id === item.friend_id) {
                console.log('items', item)
                item.tips = true
              }
            })
          })
          console.log('data', data)
        }
      } if (this.valueser === 3) {
        console.log('this.valueser :', this.valueser)
        console.log('this.obr:', this.obr)
        const data = await getCorpColleaguesUnrestricted({
          employee_no: this.employee_no
        })
        // this.total = data.data.total
        if (data.data === null) {
          this.arr = []
        } else {
          console.log(11)
          data.data.forEach((item) => {
            item.can_checked = 1
            item.tips = false
          })
          this.arr = data.data

          this.arr.forEach((item) => {
            // console.log('item', item)
            this.arrs.forEach((items) => {
              if (items.friend_id === item.friend_id) {
                console.log('items', item)
                item.tips = true
              }
            })
          })
          console.log('data', data)
        }
      } else {
        if (this.valueser === 1) return
        const data = await groupChatSetgetCorpColleagues({
          corp_id: this.corp_id,
          nickname: this.obr.nickname
        })
        // this.total = data.data.total
        if (data.data === null) {
          this.arr = []
        } else {
          data.data.forEach((item) => {
            item.can_checked = 1
            item.tips = false
            item.friend_id = item.wx_id
          })
          this.arr = data.data

          this.arr.forEach((item) => {
            // console.log('item', item)
            this.arrs.forEach((items) => {
              if (items.friend_id === item.friend_id) {
                console.log('items', item)
                item.tips = true
              }
            })
          })
          console.log('data', data)
        }
      }
    },
    // 分页
    fetchPageSize(e) {
      console.log('111')
      this.obr.pageSize = e
      this.obr.page = 1
      this.list()
    },
    fetchCurrentPage(e) {
      this.obr.page = e
      this.list()
    },
    chaerwr(val) {
      console.log(val)
      this.obr.nickname = ''
      this.list()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.allbox{
  padding: 30px;
}
.que_box{
  margin-top: 20px;
}
.have{
  color: #409eff;
}
.serch_box{
  display: flex;
  margin-bottom: 10px;
}
.search_icon{
  margin-left: 10px;
}
.band_box{
  display: flex;
}
.choses_box{
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.select_box{
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
}
.select_boxone{
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-right: 7px;
  background-color: #ccc;
}
.choose_block{
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  margin-right: 10px;
}
.choose_blockr{
  background: #409eff;
}
.rigboxr{
  margin-left: 85px;
  border-left: 1px solid #ccc;
  padding-left: 30px;
  max-height: 520px;
  overflow: hidden;
  overflow-y: scroll;
}
:-webkit-scrollbar {
     width: 0 !important;
}
::-webkit-scrollbar {
     width: 0 !important;height: 0;
  }
.choiceofficialaccount{
  margin-bottom: 10px;
}
.select_spacing{
  margin-bottom: 5px;
}
.choose_allblock{
  height: 370px;
  overflow-x: scroll;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 700px;
}
</style>
